import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, Col, FormGroup, Label, Row, Collapse, Card } from "reactstrap";
import classnames from "classnames";
import BankInformation from "../BankInformation/BankInformation";
import CorrespondentBanks from "../CorrespondentBanks/CorrespondentBanks";
import SweetAlert from "react-bootstrap-sweetalert";

const BankDetailsItems = (props) => {
  const [collapsed, setCollapsed] = React.useState(props.accordion_status);
  const [deleteAlert, setDeleteAlert] = React.useState(false);

  const applyDeleteBankDetails = (id, user) => {
    props.deleteBankDetails(id, user);
    setDeleteAlert(false);
  };

  return (
    <Row className="justify-content-md-center">

      {deleteAlert && (
        <SweetAlert
          showCancel
          confirmBtnText="Delete"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle=""
          title={"Deleting bank details"}
          onCancel={() => setDeleteAlert(false)}
          onConfirm={() => applyDeleteBankDetails(props.data.id, props.data.user)}
        >
          <p>Are you sure want to delete this bank details?</p>
        </SweetAlert>
      )}

      <Col xl={12}>
        <div
          className=""
          style={{ borderLeft: "5px solid #556EE6", margin: "10px 0" }}
        >
          <div className="accordion" id="accordion">
            <AccordionItem className={classnames("accordion-item")}>
              <h2 className="accordion-header" id="headingOne">
                <span
                  className={classnames(
                    "accordion-button fw-medium d-flex justify-content-between",
                    {
                      collapsed: !collapsed,
                    }
                  )}
                  // type="button"
                  onClick={() => setCollapsed(!collapsed)}
                  style={{ cursor: "pointer", borderTopLeftRadius: 0 }}
                >
                  <div className="w-100 m-0 m-auto d-flex justify-content-between align-items-center pe-3">
                    <span>{props.data.payment_description || `Bank Details #${props.inx}`}</span>
                    <Button
                      onClick={() => setDeleteAlert(true)}///props.onDelete || function () { }}
                      color="danger"
                      className="btn-block inner me-3 btn-sm"
                      style={{ visibility: !props.onDelete ? "hidden" : "visible" }}
                    >
                      <i className="mdi mdi-trash-can font-size-16" />
                    </Button>
                  </div>
                </span>
              </h2>

              <Collapse isOpen={collapsed} className="accordion-collapse">
                <AccordionBody className="accordion-body">
                  <Row className="">
                    <Col xl={4}>
                      <Card className="overflow-hidden" style={{ margin: 0, paddingRight: 5, minHeight: 416, height: '100%' }}>
                        {props.permissions["view_bankdetailsmodel"] && (
                          <BankInformation
                            data={props.data}
                            setEditBank={props.setEditBank}
                            loading_details={props.loading_details}
                            permissions={props.permissions}
                          />
                        )}
                      </Card>
                    </Col>

                    <Col xl={8} style={{ padding: 0, paddingLeft: 12 }}>
                      {props.permissions["view_bankcorrespondentmodel"] && (
                        <CorrespondentBanks
                          data={props.data.bank_correspondents?.length === 0 ? null : props.data.bank_correspondents[0]}
                          userId={props.data.user}
                          getBankCorespondents={props.getBankCorespondents}
                          deleteBankCorespondent={props.deleteBankCorespondent}
                          updateBankCorespondent={props.updateBankCorespondent}
                          addBankCorespondent={props.addBankCorespondent}
                          loading_corespondent={props.loading_corespondent}
                          permissions={props.permissions}
                          legal_entity_data={props.legal_entity_data}
                          legal_entity_loading={props.legal_entity_loading}
                          updateBankDetails={props.updateBankDetails}
                          bankDetails={props.data}
                          loading_details={props.loading_details}
                        />
                      )}
                    </Col>
                  </Row>
                </AccordionBody>
              </Collapse>
            </AccordionItem>
          </div>
        </div>
      </Col>
    </Row>
  );
};

const AccordionItem = styled.div`
  background-color: transparent;
  border: 0px solid rgba(0, 0, 0, 0) !important;
  margin: 0;
  cursor: initial;

  /* .accordion-button::after {
    background: none !important;
    display: none !important;
  } */

  &:first-child {
    margin-top: 0;
  }

  .accordion-button {
    padding-top: 8px;
    padding-bottom: 8px;

    &.collapsed {
      color: #4d63cf;
      background-color: #eef1fd !important;
      /* box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0 var(--bs-accordion-border-color); */
    }
  }

  .btn-danger {
    margin: 0 !important;
  }

  &.accordion-item__is-close {
    background-color: red !important;
  }
`;

const AccordionBody = styled.div`
  padding: 0 !important;
  color: #74788d !important;
`;

BankDetailsItems.propTypes = {
  isLoading: PropTypes.bool,
  suffix: PropTypes.string,
  onDelete: PropTypes.func,
  inx: PropTypes.number,
  // onChangeCountries: PropTypes.func,
  setGroups: PropTypes.func,
  accordion_status: PropTypes.bool,
  data: PropTypes.object,
  permissions: PropTypes.any,
  legal_entity_loading: PropTypes.bool,
  legal_entity_data: PropTypes.object,
  loading_details: PropTypes.bool,
  setEditBank: PropTypes.func,
  getBankCorespondents: PropTypes.func,
  deleteBankCorespondent: PropTypes.func,
  updateBankCorespondent: PropTypes.func,
  addBankCorespondent: PropTypes.func,
  loading_corespondent: PropTypes.bool,
  legal_entity_data: PropTypes.any,
  legal_entity_loading: PropTypes.bool,
  updateBankDetails: PropTypes.func,
  deleteBankDetails: PropTypes.func,
};

const FormByCostTypeStyled = styled.div`
  .btn__add-custom-event {
    color: #556ee6ff;
    cursor: pointer;
    font-size: 11px;
  }
`;

export default BankDetailsItems;
